/**
 * @desc 修改供应商账号
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.Response;
export function request(userNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierAccount/disableOrEnable/${userNo}`, {
      method: "POST",

      ...options,
    }),
  );
}
